import { useRef, useState, useEffect } from "react"
import { Row, Col, Typography, theme } from "antd"
import "remixicon/fonts/remixicon.css"
import { getDeviceData } from "../../../data/utils"

const Timeout = ({
  duration = 60,
  pulseAfter = 10,
  onTimeoutEnd = () => {},
}) => {
  const { token: themeConfig } = theme.useToken()
  const { mobile } = getDeviceData()

  const radii = mobile ? 36 : 88
  const startPos = mobile ? 40 : 96
  const strokeWidth = mobile ? 8 : 14

  const pathRef = useRef(null)
  const [elapsed, setElapsed] = useState(0)

  useEffect(() => {
    const path = pathRef.current
    const circumference = 2 * Math.PI * radii
    let elapsed = 0
    let intervalId = null

    if (path) {
      path.setAttribute("stroke-dasharray", circumference)

      intervalId = setInterval(() => {
        elapsed++
        setElapsed(elapsed)
        const offset = (elapsed / duration) * circumference
        path.setAttribute("stroke-dashoffset", offset)

        if (duration - elapsed === pulseAfter) {
          path.classList.add("pulsing")
          path.setAttribute("stroke", "url(#pulse-warn-gradient)")
        }

        if (elapsed >= duration) {
          clearInterval(intervalId)
          onTimeoutEnd()
        }
      }, 1000)
    }

    return () => {
      clearInterval(intervalId)
    }
  }, [])

  return (
    <Row
      style={{
        flexDirection: mobile ? "row-reverse" : "column",
        alignItems: "center",
        textAlign: mobile ? "left" : "center",
        gap: 16,
        zIndex: 10,
      }}
    >
      {/* Timer Container */}
      <Col
        style={{
          width: mobile ? 80 : 192,
          height: mobile ? 80 : 192,
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          background: "#EEF7FE",
          borderRadius: "50%",
          boxShadow: "inset 0px 4px 6.1px 0px #00000040",
          position: "relative",
        }}
      >
        {/* Inner Circle */}
        <div
          style={{
            width: mobile ? 64 : 160,
            height: mobile ? 64 : 160,
            background: "#EEF7FE",
            borderRadius: "50%",
            zIndex: 11,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            position: "absolute",
            margin: 8,
          }}
        >
          {/* Timer Text */}
          <div
            style={{
              width: mobile ? 48 : 144,
              height: mobile ? 48 : 144,
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "center",
              borderRadius: "50%",
              boxShadow: "0 3px 6px rgba(0,0,0,0.16)",
              background: themeConfig.colorBgContainer,
            }}
          >
            <Typography.Title
              level={mobile ? 4 : 1}
              style={{ margin: 0, fontWeight: "bold" }}
            >
              {duration - elapsed}
            </Typography.Title>
            {!mobile && (
              <Typography.Text
                style={{
                  fontSize: "1.25rem",
                  padding: "0 8px",
                  borderRadius: 8,
                }}
              >
                sec
              </Typography.Text>
            )}
          </div>
        </div>

        {/* SVG Circle */}
        <svg
          height="100%"
          style={{ transform: "scaleX(-1)" }}
          xmlns="http://www.w3.org/2000/svg"
        >
          <defs>
            <linearGradient
              id="gradientStroke"
              x1="0%"
              y1="0%"
              x2="0%"
              y2="100%"
            >
              <stop offset="0%" stopColor="#BCDFFB" />
              <stop offset="33.5%" stopColor="#74B0E0" />
              <stop offset="64.5%" stopColor="#399CED" />
              <stop offset="100%" stopColor="#0076D6" />
            </linearGradient>

            <linearGradient
              id="pulse-warn-gradient"
              x1="0%"
              y1="0%"
              x2="0%"
              y2="100%"
            >
              <stop id="stop1" offset="0%" stopColor="#da3a3a" />
              <stop id="stop2" offset="100%" stopColor="#da3a3a" />
            </linearGradient>
          </defs>

          <circle
            ref={pathRef}
            cx={startPos}
            cy={startPos}
            r={radii}
            stroke="url(#gradientStroke)"
            strokeWidth={strokeWidth}
            fill="none"
            strokeDashoffset="0"
            strokeLinecap="round"
            transform={`rotate(-90 ${startPos} ${startPos})`}
          />
        </svg>
      </Col>

      {/* Offer Text */}
      <Typography.Title
        level={mobile ? 4 : 1}
        style={{
          color: "white",
          fontWeight: "bold",
          flexGrow: 1,
          textAlign: "center",
          lineHeight: 1.2,
          margin: 0,
          display: "flex",
          flexDirection: "column", 
          justifyContent: "center",
          alignItems: "center",
          gap: "0.25em", 
          flexWrap: "wrap", 
          fontSize: "52px"
        }}
      >
        <span style={{ whiteSpace: "nowrap" }}>Limited</span>
        <span style={{ whiteSpace: "nowrap" }}>Time</span>
        <span style={{ whiteSpace: "nowrap" }}>Offer</span>
      </Typography.Title>
    </Row>
  )
}

export default Timeout
